// [NEW FILE] PM-9: the one setting kept on top of the original Scoring & ratings page: which final ratings start an
// improvement plan (PIP) draft automatically when HR finalises. Saving creates a new rating scheme version with the
// same weights and bands, so running cycles keep the version they started with.
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { FiSave } from "react-icons/fi";
import { Card, Button } from "../../../components/common";
import Select from "../../../components/common/Select";
import { updateRatingSettings } from "../../../services/settingsApi";
import { getErrorMessage } from "../../../utils/errors";

export default function PipRuleCard({ data, onSaved }) {
  const [pipBands, setPipBands] = useState(0);
  const [saving, setSaving] = useState(false);
  useEffect(() => { setPipBands(Number(data?.pipBands) || 0); }, [data]);
  if (!data || data.readOnly) return null;

  const lowest = [...(data.bands || [])].sort((a, b) => Number(a.min) - Number(b.min));
  const save = async () => {
    setSaving(true);
    try {
      const { data: saved } = await updateRatingSettings({ weights: data.weights, bands: data.bands, pipBands });
      toast.success(saved.approved ? "Automatic PIP rule saved and approved." : "Automatic PIP rule saved as a draft; it needs approval.");
      onSaved?.();
    } catch (err) {
      toast.error(getErrorMessage(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Card
      title="Automatic improvement plan (PIP)"
      subtitle="When HR finalises a rating in these bands, a PIP draft is created for the employee and their manager."
      actions={<Button size="sm" icon={FiSave} loading={saving} disabled={pipBands === (Number(data.pipBands) || 0)} onClick={save}>Save rule</Button>}
    >
      <label className="form-field" style={{ maxWidth: 520 }}>
        <span className="form-label">Start a PIP draft automatically when the final rating is</span>
        <Select keepOrder className="form-control" value={pipBands} onChange={(e) => setPipBands(Number(e.target.value))}>
          <option value={0}>Never (switched off)</option>
          {lowest.slice(0, 3).map((b, i) => (
            <option key={b.label} value={i + 1}>{lowest.slice(0, i + 1).map((x) => x.label).join(" or ")}</option>
          ))}
        </Select>
      </label>
    </Card>
  );
}
